import _ from 'lodash';
import React, { useContext, useEffect, useMemo, useState } from 'react';
import { fbAppConfigs } from '../../../../project/appConfigs';
import { envTypes } from '../../../../project/appConfiguration';
import { CreateContext } from '../../../cnr/contexts/CreateContext';
import GoogleSheetsProvider, { GoogleSheetsContext } from '../../../cnr/contexts/GoogleSheetsContext';
import { ParentContext } from '../../../cnr/contexts/ParentContext';
import { viewDataModes } from '../../../cnr/reducers/DataManagmentReducer';
import { googleSheetsTypes } from '../../../cnr/reducers/GoogleSheetsReducer';
import { convertHelpers } from '../../../common/convert';
import { _ignoreKeys } from '../../../common/dataFix';
import UiSaveButtons from '../../../components/buttons/UiSaveButtons';
import DataSidebar from '../../../components/swipers/DataSidebar';
import { allDataModes } from '../../../components/viewers/AppDashboard';
import { GoogleDashboard } from '../../../components/viewers/GoogleDashboard';
import RegDataViewerWithProvider from '../../../components/viewers/RegDataViewer';
import TreeViewer from '../../../components/viewers/TreeViewer';
import { appIconTypes } from '../../../enums/appIconTypes';
import SidebarWrapper from '../../../wrappers/SidebarWrapper';
import Wrapper, { wrapperTypes } from '../../../wrappers/Wrapper';
import { gEnums } from 'global/enums/globalEnums';

export const createEventTypes = {
  merge: 'merge',
  previous: 'previous',
  reg: 'reg',
  regAndGoogleSheets: 'regAndGoogleSheets',
}

const _sidebarModes = {
  createEvent: 'createEvent',
  createEvent_limited: 'createEvent_limited',
  createGsEvent: 'createGsEvent',
  recreateEvent: 'recreateEvent',
  tempEvent: 'tempEvent',
  mergeEvent: 'mergeEvent',
  viewJson: 'viewJson'
}

const CreateEvent = ({ createEventType, addModeType, currentDataMode }) => {

  console.log('addModeType', addModeType)

  // parentContext
  const parentContext = useContext(ParentContext)
  const { states, settings } = parentContext ?? {}
  const { appUser_state, paps_state } = states ?? {}
  const { appUser } = appUser_state ?? {}
  const { appUserAccess } = appUser ?? {}
  const { isSuperAdminDeveloper } = appUserAccess ?? {}
  const { pathViews } = paps_state ?? {}
  const { events: eventKey } = pathViews ?? {}
  const { clientSettings } = settings ?? {}

  // createContext
  const createContext = useContext(CreateContext)
  const { create_handlers, create_state } = createContext ?? {}
  const { projectResult, updating: updating_cr, updatingCaption: updatingCaption_cr, createType } = create_state ?? {}

  // googleSheetsContext
  const googleSheetsContext = useContext(GoogleSheetsContext);
  const { googleSheets_state, googleSheets_handlers } = googleSheetsContext ?? {}
  const {
    dashboardInfo_merged,
    googleSheetsPreview,
    updating: updating_gs,
    updatingCaption: updatingCaption_gs,
    projectOptions,
    themeColors,
    gsSuccess
  } = googleSheets_state ?? {}

  const { projectSettings } = dashboardInfo_merged ?? {}
  const { global } = projectSettings ?? {}

  if (googleSheetsPreview && dashboardInfo_merged && dashboardInfo_merged.projectSettings) {
    googleSheetsPreview.projectSettings = dashboardInfo_merged.projectSettings
  }

  const [regInfo] = useState({});
  const [destination, setDestination] = useState({})
  const [config_alt, setConfig_alt] = useState()
  const [sidebarMode, setSidebarMode] = useState()
  const [formUpdates, setFormUpdates] = useState({})
  const [_createData, setCreateData] = useState()

  const { appDataSource, appStatus, dataOptions, parentDefaults } = formUpdates ?? {}

  const { environment, appName } = destination ?? {}
  const _env = environment === envTypes.development ? 'dev' : 'prod'

  const eventOptions = {
    appStatus,
    parentDefaults,
    projectOptions,
    themeColors,
  }

  let steps;


  const _cd = useMemo(() => projectResult ?? googleSheetsPreview, [projectResult, googleSheetsPreview]);

  const _documentsData = useMemo(() => {
    if (!_cd) return null;
    const { projectData } = _cd;
    const { dataCollections } = projectData ?? {};
    return convertHelpers.createDocumentData(dataCollections);
  }, [_cd]);

  const _documentsDatas = useMemo(() => {
    if (!_documentsData) return null;
    return convertHelpers.ammendRelatedObjects(_documentsData, _ignoreKeys);
  }, [_documentsData]);

  const updatedCreateData = useMemo(() => {
    if (!_createData || !appDataSource) return _createData;
    // Check if the object is actually different before returning a new reference
    if (_createData.projectSettings?.global?.appDataSource === appDataSource) {
      return _createData;
    }

    return {
      ..._createData,
      projectSettings: {
        ..._createData.projectSettings,
        global: {
          ...(_createData.projectSettings?.global ?? {}),
          appDataSource,
        },
      },
    };
  }, [_createData, appDataSource]);

  useEffect(() => {
    // Prevent unnecessary re-renders by checking if values actually changed
    // setDocumentsData(prev => (prev === _documentsData ? prev : _documentsData));
    // setDocumentsDatas(prev => (prev === _documentsDatas ? prev : _documentsDatas));
    setCreateData(prev => (prev === _cd ? prev : _cd));
  }, [_documentsData, _documentsDatas, _cd]);

  useEffect(() => {
    // Prevent unnecessary state updates
    setCreateData(prev => (prev === updatedCreateData ? prev : updatedCreateData));
  }, [updatedCreateData]);

  useEffect(() => {
    if (_createData) {
      // update global with the eventOptions
      const _previewInfo = { ..._createData }

      if (eventOptions) {
        _.keys(eventOptions).forEach(key => {
          _previewInfo.projectSettings.global[key] = eventOptions[key]
        })
      }

      if (appDataSource) {
        _previewInfo.projectSettings.global.appDataSource = appDataSource
      }

      switch (createEventType) {
        case createEventTypes.reg:
          create_handlers.handleUpdate_projectResult(_previewInfo)
          break;

        default:
          googleSheets_handlers.handleSet_previewInfo(_previewInfo)
      }
    }

    const { global: global_client } = clientSettings ?? {}
    const { themeColors: themeColors_client } = global_client ?? {}
    if (themeColors_client) { googleSheets_handlers.handleSet_themeColors(themeColors_client) }

    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, [projectOptions, themeColors, appStatus, parentDefaults]);

  useEffect(() => {
    if (appName && environment) {
      const _config_alt = fbAppConfigs[appName][_env]
      setConfig_alt(_config_alt)
    }
    // eslint-disable-next-line
  }, [appName, environment]);

  useEffect(() => {
    if (global) {
      const { appDataSource: _appDataSource } = global ?? {}
      const _formUpdates = { ...formUpdates }
      _formUpdates['appDataSource'] = _appDataSource
      setFormUpdates(_formUpdates)
    }
    // eslint-disable-next-line
  }, [global]);

  const handleProjectOptions = (projectOptions) => googleSheets_handlers.handleSet_projectOptions(projectOptions)
  const handleThemeColors = (themeColors) => googleSheets_handlers.handleSet_themeColors(themeColors)

  const handleFormUpdate = (data, settingsType, forSave) => {
    const _formUpdates = { ...formUpdates }
    _formUpdates[settingsType] = data
    setFormUpdates(_formUpdates)
  }

  const handlePreviousPreviewInfo = (previousEventSettings) => {
    googleSheets_handlers.handleStartUpdate()
    googleSheets_handlers.handleGet_previousPreviewInfo(previousEventSettings)
  }
  const handleDestination = (d) => setDestination(d)
  const handleShowSidebar = (opts) => setSidebarMode(opts.sidebarMode)

  /**
   * creates the event in the database
   */
  const handleCreate = (opts) => setSidebarMode(opts?.viewDataMode)

  const handleCreateInDb = (opts) => {
    // createInfo, recreate, addModeType, config_alt, destination, viewDataMode
    const { viewDataMode } = opts
    switch (viewDataMode) {
      case viewDataModes.createEvent:
      case viewDataModes.createEvent_limited:
        googleSheets_handlers.handleStartUpdate()
        googleSheets_handlers.handleCreate_eventFromGs(null, null, addModeType, config_alt, destination, viewDataMode)
        break;
      case viewDataModes.createGsEvent:
        googleSheets_handlers.handleStartUpdate()
        googleSheets_handlers.handleCreate_eventFromGs(null, null, gEnums.addModeTypes.googleSheets, config_alt, destination, viewDataMode)
        break;
      case viewDataModes.recreateEvent:
        googleSheets_handlers.handleCreate_eventFromGs(null, true, addModeType, config_alt, destination, viewDataMode)
        break;
    }
  }

  const handleRecreateInDb = () => {
    switch (createEventType) {
      case createEventTypes.reg:
        create_handlers.handleStartUpdate()
        create_handlers.handleCreate_clientOrEventInDb()
        break;
      default:
        googleSheets_handlers.handleStartUpdate()
        googleSheets_handlers.handleCreate_eventFromGs(null, true, addModeType, config_alt, destination)
    }
  }

  const handleCreate_temp = () => {
    switch (createEventType) {
      case createEventTypes.reg:
        create_handlers.handleStartUpdate()
        create_handlers.handleCreate_clientOrEventInDb()
        break;
      default:
        googleSheets_handlers.handleStartUpdate()
        googleSheets_handlers.handleCreate_eventFromGs(null, null, addModeType, config_alt, destination)
    }
  }

  const handleMerge = () => {
    switch (createEventType) {
      case createEventTypes.reg:
        create_handlers.handleStartUpdate()
        create_handlers.handleCreate_clientOrEventInDb()
        break;
      default:
        googleSheets_handlers.handleStartUpdate()
        googleSheets_handlers.handleCreate_eventFromGs()
    }
  }

  const _googleDashboard = () => <GoogleDashboard noModal={true} fromCreate={true} handleCreate={handleCreate} />
  const _regData = () => <RegDataViewerWithProvider noModal={true} fromCreate={true} />

  const buttons_create = () => {
    const btns = []
    switch (createEventType) {
      case createEventTypes.merge:
        btns.push({ oc: handleMerge, caption: 'Merge Event', color: 'blue', disabled: !_createData, icon: appIconTypes.arrowRight })
        break;
      default:
        switch (sidebarMode) {
          case _sidebarModes.createEvent:
            btns.push({ oc: handleCreateInDb, caption: 'Create Event', color: 'green', disabled: !_createData, icon: appIconTypes.save, opts: { viewDataMode: viewDataModes.createEvent } })
            break;
          case _sidebarModes.createEvent_limited:
            btns.push({ oc: handleCreateInDb, caption: 'Create Event Limited', color: 'green', disabled: !_createData, icon: appIconTypes.save, opts: { viewDataMode: viewDataModes.createEvent_limited } })
            break;
          case _sidebarModes.createGsEvent:
            btns.push({ oc: handleCreateInDb, caption: 'Create Gs Event', color: 'green', disabled: !_createData, icon: appIconTypes.save, opts: { viewDataMode: viewDataModes.createGsEvent } })
            break;
          case _sidebarModes.recreateEvent:
            btns.push({ oc: handleRecreateInDb, caption: 'Recreate Event', color: 'green', disabled: !_createData, icon: appIconTypes.save })
            break;
          case _sidebarModes.tempEvent:
            btns.push({ oc: handleCreate_temp, caption: 'Create Temp Event', color: 'blue', disabled: !_createData, icon: appIconTypes.save })
            break;
        }
    }
    return <UiSaveButtons others={btns} />
  }

  const content_right = () => {

    const create_info = _.cloneDeep(_createData)

    if (create_info?.projectData?.dataCollections?.attendees) {
      console.log('aaa', _.fromPairs(_.take(_.toPairs(create_info.projectData.dataCollections.attendees), 50)))
      create_info.projectData.dataCollections.attendees = _.fromPairs(_.take(_.toPairs(create_info.projectData.dataCollections.attendees), 50));
    }

    return <Wrapper
      header={'Confirmation'}
      content={<TreeViewer data={create_info} subNames={true} scNames={true} />}
      footer={buttons_create()}
      wrapperType={wrapperTypes.padded}
    />
  }

  const sidebar_right = (visible) => <DataSidebar direction={'right'} visible={visible} content={visible && content_right()} onHide={setSidebarMode} />

  const content = () => {
    switch (currentDataMode) {
      case allDataModes.createEvent:
      case allDataModes.createEvent_limited:
      case allDataModes.regDashboard:
      case allDataModes.recreateEvent:
        return _googleDashboard()
      default:
        return _googleDashboard()
    }
  }

  const sidebar = () => <SidebarWrapper
    sidebarContent={content()}
    sidebarRight={sidebar_right(sidebarMode)}
    sidebarOn={sidebarMode}
  />

  return sidebar()

}

export const CreateEventWithProvider = (props) => {
  return <GoogleSheetsProvider googleSheetsType={googleSheetsTypes.create}>
    <CreateEvent {...props} />
  </GoogleSheetsProvider>
}